<!--
    Props
        - dialog_opened - Controla o estado de visibilidade do dialog
        - title - Titulo principal da caixa do modal
        - message - Mensagem principal do dialogo
        - btn_1_text - First button text        
        - btn_2_text - First button text
    Events
        - btn_1_clicked - Disparado quando o botão 1 é clicado
        - btn_2_clicked - Disparado quando o botão 2 é clicado
-->
<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog_opened" persistent max-width="290">      
      <v-card>
        <v-card-title class="headline" justify-center v-if="title">{{title}}</v-card-title>
        <v-card-text v-if="message">{{message}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="btn_1_text" color="green darken-1" flat @click="$emit('btn_1_clicked')">{{btn_1_text}}</v-btn>
          <v-btn v-if="btn_2_text" color="green darken-1" flat @click="$emit('btn_2_clicked')">{{btn_2_text}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
  export default {
    props:{
        dialog_opened:Boolean,
        title:String,
        message:String,
        btn_1_text:String,
        btn_2_text:String,
    },
    data () {
      return {       
      }
    }
  }
</script>